import React from "react";

import { useIntl } from "react-intl";

import MapFilter, { getMapFilterDisplayName } from "../../enums/MapFilter";

import styles from "./BaseMapFilter.module.scss";
import BaseMapFilterProps from "./BaseMapFilterProps";
import FilterItem from "./FilterItem";

const filterList = [
  MapFilter.CLOSED_WON_REVENUE,
  MapFilter.CLOSED_LOST_REVENUE,
  MapFilter.NUMBER_OF_CLOSED_WON_DEALS,
  MapFilter.NUMBER_OF_CLOSED_LOST_DEALS,
];

interface Props extends BaseMapFilterProps {}

const DealGeographyMapFilter: React.FC<Props> = ({ filter, onChange }) => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      {filterList.map((option) => (
        <FilterItem
          currentFilter={filter}
          filter={option}
          key={option}
          onClick={onChange}
          title={getMapFilterDisplayName(intl, option)}
        />
      ))}
    </div>
  );
};

export default DealGeographyMapFilter;
